import React from 'react';

import Box from '@mui/material/Box';

import useQueryParams from '@common/hooks/use-query-params';

const Main = ({ children }) => {
  const { printLayout } = useQueryParams();

  return (
    <Box
      component="main"
      sx={
        /* printLayout will === '1' when exporting Student Portfolio entries */
        printLayout !== '1'
          ? {
              flex: 1,
              height: '100%',
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column'
            }
          : {}
      }
    >
      {children}
    </Box>
  );
};

export default Main;
